import { BasicContent } from './BasicContent';
import RichText from './RichText';
import PinkBarVsSteelCalculator from '../../composites/PinkBarVsSteel/PinkBarVsSteelCalculator';

const CMSPinkBarVsSteelCalculator = ({ content, calculator }) => (
  <>
    <BasicContent {...content.copy} />
    <PinkBarVsSteelCalculator laborRate={calculator.laborRate} />
    <RichText content={content.footnotes} />
  </>
);

export default CMSPinkBarVsSteelCalculator;
